// src/router/cargos.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['peopleCulture']

const cargosBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Cargos',
        to: 'Cargos'
    }
]

export default [
    {
        path: '/cargos',
        name: 'Cargos',
        component: () => import('@/views/Cargos/CargoListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Cargos',
            breadcrumb: cargosBreadCrumb
        },
    },
    {
        path: '/cargos/novo',
        name: 'CargoNovo',
        component: () => import('@/views/Cargos/NovoCargoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Cargo',
            breadcrumb: [
                ...cargosBreadCrumb,
                {
                    label: 'Novo Cargo',
                    to: 'CargoNovo'
                }
            ]
        }
    },
    {
        path: '/cargos/:id/edit',
        name: 'CargoEdit',
        component: () => import('@/views/Cargos/NovoCargoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Cargo',
            breadcrumb: [
                ...cargosBreadCrumb,
                {
                    label: 'Novo Cargo',
                    to: 'CargoNovo'
                }
            ]
        }
    }

];
